<ng-template [ngIf]="!isMeVersion()">
  <ng-template [ngIf]="isUserTeacher">
    <app-profile-sidebar-widget [user]="user"></app-profile-sidebar-widget>
  </ng-template>
</ng-template>

<ng-template [ngIf]="loaded && isMeVersion() && isMe">
  <app-user-widget [withoutCover]="true" [user]="user"></app-user-widget>
</ng-template>
